import React from 'react';
import {SimpleDropdownProps} from '../types';
import {Readonly} from './Readonly';
import {Searchable} from './Searchable';

export const SimpleDropdown: React.FC<SimpleDropdownProps> = ({
  items,
  favourites,
  icons,
  placeholder,
  readonly = true,
  selectedIndex,
  onSelectedIndexChange,
  onRenderBadge,
}) => {
  return readonly ? (
    <Readonly
      items={items}
      favourites={favourites}
      icons={icons}
      placeholder={placeholder}
      selectedIndex={selectedIndex}
      onSelectedIndexChange={onSelectedIndexChange}
      onRenderBadge={onRenderBadge}
    />
  ) : (
    <Searchable
      items={items}
      favourites={favourites}
      icons={icons}
      placeholder={placeholder}
      selectedIndex={selectedIndex}
      onSelectedIndexChange={onSelectedIndexChange}
      onRenderBadge={onRenderBadge}
    />
  );
};
